export default __webpack_public_path__ + "static/media/list-icon.ab2a4d4c.svg";